import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  disconnectTelegramLink,
  getTelegramLinkStatus,
  issueTelegramLinkToken,
  telegramLinkQueryKey,
} from '../api/telegram-linking.client.js';

export function useTelegramLinkStatus() {
  const scope = useCurrentScope();
  return useQuery({
    queryKey: telegramLinkQueryKey(scope?.workspaceId ?? 'anonymous'),
    queryFn: getTelegramLinkStatus,
    enabled: scope !== null,
    refetchInterval: (query) => (query.state.data?.status === 'active' ? false : 5_000),
  });
}

export function useTelegramLinkMutations() {
  const scope = useCurrentScope();
  const client = useQueryClient();
  const key = telegramLinkQueryKey(scope?.workspaceId ?? 'anonymous');
  return {
    issue: useMutation({ mutationFn: issueTelegramLinkToken, gcTime: 0 }),
    disconnect: useMutation({
      mutationFn: disconnectTelegramLink,
      onSuccess: async () => client.invalidateQueries({ queryKey: key }),
    }),
  };
}
